import { render } from "./blog_evento.vue?vue&type=template&id=2a28f9b3&scoped=true"
import script from "./blog_evento.vue?vue&type=script&lang=js"
export * from "./blog_evento.vue?vue&type=script&lang=js"

import "./blog_evento.vue?vue&type=style&index=0&id=2a28f9b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a28f9b3"]])

export default __exports__